import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import { Context } from "../context";
import { getDataById, getImage } from './utils';

export function Project({uniq, title, color, img, videos, users}) {
  const context = useContext(Context);
  return (
    <>
      <div className="x_project">


        <Link
          to={`/list/${uniq}`}
          className="x_cover0 x_cover0--sm">
          <div className="x_header_pic" />
          <div className="x_cover_content x_cover_content--project">
            <div className="x_cover_title0">
              <div className="x_cover_h1">
                <div className="x_cover_emoji">
                <div className="x_cover_image"
                  style={{ backgroundImage: `url(${getImage(img)})` }}
                >

                </div>
                </div>
                <div className="x_cover_title">
                  {title}
                </div>
              </div>
              {/* <div className="x_cover_h2">
                <div className="x_cover_createdby">Started:</div>
                <div className="x_user">
                  <div>
                    <span>15 Oct 2021</span>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </Link>


        <div className="x_project_info">
          <div className="x_project_info_line">
            <div className="x_project_info_label">
              <div>Team</div>
            </div>
            <div className="x_project_info_value">
              <div className="x_project_ul">

                {users && users.map(userId => {
                  let userData = getDataById(context, 'users', userId)
                  return (<div
                  className="x_project_li"
                  key={`user_${title}_${userData['name']}`}
                >
                  <img
                    src={getImage(userData['img'])}
                    loading="lazy"
                    className="p_user_ava_img"
                  />
                  <div className="x_project_team_name">
                    {userData['name']}
                  </div>
                </div>)}
                )}


              </div>
            </div>
          </div>


          {/* <div className="x_project_info_line">
            <div className="x_project_info_label">
              <div>Apps</div>
            </div>
            <div className="x_project_info_value">
              <div className="x_project_ul">

                <div
                  className="x_project_li"
                >
                  <img
                    src="https://assets.website-files.com/61785133118e574036320746/617c932f5be6870fd4dac6bf_danny.jpeg"
                    loading="lazy"
                                        className="p_user_ava_img"
                  />
                  <div className="x_project_team_name">
                    <div>Danny Andreev</div>
                  </div>
                </div>

              </div>
            </div>
          </div> */}


          {/* <div className="x_project_info_line">
            <div className="x_project_info_label">
              <div>Highlighs</div>
            </div>
            <div className="x_project_info_value">
              <div className="x_project_ul">
                <div className="x_project_li">
                  <div className="x_project_li">
                    <div className="p_comment_time0">
                      <div className="p_comment_time_frame p_comment_time_frame--mini">
                        <img
                          src="https://assets.website-files.com/61785133118e574036320746/617bb33ea5c8d3a0ec6393a2_Screen%20Shot%202021-10-29%20at%201.38.54%20AM.png"
                          loading="lazy"
                          sizes="44px"
                          srcSet="https://assets.website-files.com/61785133118e574036320746/617bb33ea5c8d3a0ec6393a2_Screen%20Shot%202021-10-29%20at%201.38.54%20AM-p-500.png 500w, https://assets.website-files.com/61785133118e574036320746/617bb33ea5c8d3a0ec6393a2_Screen%20Shot%202021-10-29%20at%201.38.54%20AM.png 700w"
                                                  />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="x_project_li">
                  <div className="x_project_li">
                    <div className="p_comment_time0">
                      <div className="p_comment_time_frame p_comment_time_frame--mini">
                        <img
                          src="https://assets.website-files.com/61785133118e574036320746/617bb33ea5c8d3a0ec6393a2_Screen%20Shot%202021-10-29%20at%201.38.54%20AM.png"
                          loading="lazy"
                          sizes="44px"
                          srcSet="https://assets.website-files.com/61785133118e574036320746/617bb33ea5c8d3a0ec6393a2_Screen%20Shot%202021-10-29%20at%201.38.54%20AM-p-500.png 500w, https://assets.website-files.com/61785133118e574036320746/617bb33ea5c8d3a0ec6393a2_Screen%20Shot%202021-10-29%20at%201.38.54%20AM.png 700w"
                                                  />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="x_project_li">
                  <div className="x_project_li">
                    <div className="p_comment_time0">
                      <div className="p_comment_time_frame p_comment_time_frame--mini">
                        <img
                          src="https://assets.website-files.com/61785133118e574036320746/617bb33ea5c8d3a0ec6393a2_Screen%20Shot%202021-10-29%20at%201.38.54%20AM.png"
                          loading="lazy"
                          sizes="44px"
                          srcSet="https://assets.website-files.com/61785133118e574036320746/617bb33ea5c8d3a0ec6393a2_Screen%20Shot%202021-10-29%20at%201.38.54%20AM-p-500.png 500w, https://assets.website-files.com/61785133118e574036320746/617bb33ea5c8d3a0ec6393a2_Screen%20Shot%202021-10-29%20at%201.38.54%20AM.png 700w"
                                                  />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="x_project_li">
                  <div className="x_project_li">
                    <div className="p_comment_time0">
                      <div className="p_comment_time_frame p_comment_time_frame--mini">
                        <img
                          src="https://assets.website-files.com/61785133118e574036320746/617bb33ea5c8d3a0ec6393a2_Screen%20Shot%202021-10-29%20at%201.38.54%20AM.png"
                          loading="lazy"
                          sizes="44px"
                          srcSet="https://assets.website-files.com/61785133118e574036320746/617bb33ea5c8d3a0ec6393a2_Screen%20Shot%202021-10-29%20at%201.38.54%20AM-p-500.png 500w, https://assets.website-files.com/61785133118e574036320746/617bb33ea5c8d3a0ec6393a2_Screen%20Shot%202021-10-29%20at%201.38.54%20AM.png 700w"
                                                  />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="x_project_li">
                  <div className="x_project_li">
                    <div className="p_comment_time0">
                      <div className="p_comment_time_frame p_comment_time_frame--mini">
                        <img
                          src="https://assets.website-files.com/61785133118e574036320746/617bb33ea5c8d3a0ec6393a2_Screen%20Shot%202021-10-29%20at%201.38.54%20AM.png"
                          loading="lazy"
                          sizes="44px"
                          srcSet="https://assets.website-files.com/61785133118e574036320746/617bb33ea5c8d3a0ec6393a2_Screen%20Shot%202021-10-29%20at%201.38.54%20AM-p-500.png 500w, https://assets.website-files.com/61785133118e574036320746/617bb33ea5c8d3a0ec6393a2_Screen%20Shot%202021-10-29%20at%201.38.54%20AM.png 700w"
                                                  />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}


          <div className="x_project_info_line">
            <div className="x_project_info_label">
              <div>Data</div>
            </div>
            <div className="x_project_info_value">
              <div className="x_project_ul x_project_ul--v">
                <div className="x_project_li x_project_li--meta">
                  <div className="x_project_meta_label">
                    <div className="l_thumb_info_type">
                      <div className="p_player_emoji">
                        <div>🫒</div>
                      </div>
                    </div>
                    <div>Bevels</div>
                  </div>
                  <div className="x_project_meta_llabel_q">
                    <div>144415</div>
                  </div>
                  <div className="x_project_meta_value">
                    <div className="l_thumb_info_progress" />
                  </div>
                </div>
                <div className="x_project_li x_project_li--meta">
                  <div className="x_project_meta_label">
                    <div className="l_thumb_info_type">
                      <div className="p_player_emoji">
                        <div>🫒</div>
                      </div>
                    </div>
                    <div>Explosions</div>
                  </div>
                  <div className="x_project_meta_llabel_q">
                    <div>12344</div>
                  </div>
                  <div className="x_project_meta_value">
                    <div className="l_thumb_info_progress" />
                  </div>
                </div>
                <div className="x_project_li x_project_li--meta">
                  <div className="x_project_meta_label">
                    <div className="l_thumb_info_type">
                      <div className="p_player_emoji">
                        <div>🫒</div>
                      </div>
                    </div>
                    <div>Bevels</div>
                  </div>
                  <div className="x_project_meta_llabel_q">
                    <div>144415</div>
                  </div>
                  <div className="x_project_meta_value">
                    <div className="l_thumb_info_progress" />
                  </div>
                </div>
                <div className="l_thumbs_vid_info_line" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
